const supportedProfileLanguages = ['ua', 'ru', 'en'];
const languageSuffixes = { ua: 'Ua', ru: 'Ru', en: 'En' };

const normalizeLanguage = (value) => (supportedProfileLanguages.includes(value) ? value : 'ua');
const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');

const resolveTranslations = (profile, key) => profile?.[`${key}Translations`] || profile?.translations?.[key] || null;

const resolveDirectLocalized = (profile, key, language) => {
  const suffix = languageSuffixes[language];
  if (!suffix) {
    return '';
  }
  return normalizeText(profile?.[`${key}${suffix}`]);
};

export const getLocalizedProfileField = (profile, key, language) => {
  const normalizedLanguage = normalizeLanguage(language);
  const translations = resolveTranslations(profile, key);
  const translatedValue = normalizeText(translations?.[normalizedLanguage]);
  const directValue = resolveDirectLocalized(profile, key, normalizedLanguage);
  const uaFallback =
    normalizeText(translations?.ua)
    || resolveDirectLocalized(profile, key, 'ua')
    || normalizeText(profile?.[key]);

  return translatedValue || directValue || uaFallback || '';
};

export const getProfileTranslations = (profile, key, options = {}) => {
  const { fillMissingWithBase = false } = options;
  const translations = resolveTranslations(profile, key) || {};
  const baseValue = normalizeText(profile?.[key]);

  return supportedProfileLanguages.reduce((acc, lang) => {
    const direct = resolveDirectLocalized(profile, key, lang);
    const uaFallback =
      normalizeText(translations?.ua)
      || resolveDirectLocalized(profile, key, 'ua')
      || baseValue;
    const fallback = fillMissingWithBase ? baseValue : uaFallback;

    acc[lang] = translations[lang] || direct || fallback || '';
    return acc;
  }, {});
};

export const profileLanguages = supportedProfileLanguages;
export const normalizeProfileLanguage = normalizeLanguage;
